<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>BaseBall in Denver</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">CONTENTS</p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span class="remove" href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span class="remove" href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span class="remove" href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2" id="INAck"><a class="remove" href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2" id="INIntro"><a class="remove" href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td id="IN1"><span class="remove" href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span class="remove" href="#/Chapter1#C1" title="Link target outside of Sample">Pioneers and Places</span></td></tr>
<tr><td id="IN2"><span class="remove" href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span class="remove" href="#/Chapter2#C2" title="Link target outside of Sample">The Denver Post Tournament</span></td></tr>
<tr><td id="IN3"><span class="remove" href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span class="remove" href="#/Chapter3#C3" title="Link target outside of Sample">Semipro, Collegiate, Amateur, and Youth</span></td></tr>
<tr><td id="IN4"><span class="remove" href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span class="remove" href="#/Chapter4#C4" title="Link target outside of Sample">Denver Bears</span></td></tr>
<tr><td id="IN5"><span class="remove" href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span class="remove" href="#/Chapter5#C5" title="Link target outside of Sample">Barnstormers and More Local Legends</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1b6dafc0